<script setup lang="ts">
import { Button } from '@/components/ui/button'
import { useRouter } from 'vue-router'
import MainLayout from '@/components/layout/MainLayout.vue'
import { computed } from 'vue'
import GetMaxingCard from '@/components/GetMaxingCard.vue'
import { formatMoney } from '@/lib/utils/money'
import { usePensionCalculations } from '@/composables/usePensionCalculations'
import TaxbackCreditsAccordion from '@/components/TaxbackCreditsAccordion.vue'
import { useTaxbackCredits } from '@/composables/useTaxbackCredits'

const router = useRouter()
const { taxback, maxTaxback } = usePensionCalculations()
const { processedForms } = useTaxbackCredits()

const today = new Date()
const currentYear = today.getFullYear()
const endOfYear = new Date(currentYear, 11, 31)
const diffTime = endOfYear.getTime() - today.getTime()
const daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

const progressPercentage = computed(() => {
  if (!maxTaxback.value) return 0
  return (taxback.value / maxTaxback.value) * 100
})
</script>

<template>
  <MainLayout>
    <div class="flex flex-col gap-8 py-8">
      <h1 class="text-2xl font-bold text-center">Overview</h1>

      <div class="flex flex-col gap-4">
        <p class="text-lg text-center">
          You have
          <span class="font-bold">{{ daysLeft }} days</span> remaining<br />
          to MAX OUT for {{ currentYear }}
        </p>

        <div class="flex justify-center w-full">
          <GetMaxingCard />
        </div>
      </div>

      <div class="flex flex-col gap-2">
        <h2 class="text-md text-center">My Tax Refund so far</h2>

        <!-- Progress bar -->
        <div class="relative h-[50px] bg-[#E0E0E0] rounded-2xl overflow-hidden">
          <div
            class="absolute h-full bg-[#303F9F] rounded-full transition-all duration-500"
            :style="{ width: `${progressPercentage}%` }"
          ></div>
          <div class="absolute inset-0 flex justify-between items-center">
            <span
              class="ml-2.5 text-white font-medium bg-accent px-2 py-1 rounded-full"
            >
              {{ formatMoney(taxback) }}
            </span>
            <span
              class="mr-2.5 text-white font-medium bg-accent px-2 py-1 rounded-full"
            >
              {{ formatMoney(maxTaxback) }}
            </span>
          </div>
        </div>
        <div class="flex justify-center mt-1">
          <Button
            size="lg"
            class="w-full py-6 rounded-full text-md"
            @click="router.push('/tax-refund-options')"
          >
            Tax Refund Options
          </Button>
        </div>
      </div>

      <!-- Filed Form 11s -->
      <div class="flex flex-col gap-2 pb-24">
        <TaxbackCreditsAccordion :forms="processedForms" />
      </div>
    </div>
  </MainLayout>
</template>

<style scoped>
.progress-text {
  background: rgba(0, 0, 0, 0.1);
  padding: 2px 8px;
  border-radius: 999px;
}
</style>
